var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "runs-box" }, [
    _c("div", { staticClass: "d-flex justify-content-between" }, [
      _c("div", { staticClass: "font-weight-bold" }, [
        _vm._v(_vm._s(_vm._f("trans")("Analyze Area"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("p", [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm._f("trans")(
                "Which area should the AI look at to better understand the context in which it should modify the image."
              )
            ) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "runs-container" }, [
        _c(
          "div",
          {
            staticClass: "runs-btn",
            class: {
              active:
                _vm.activeStage.settings.inpainting_area === "only_masked",
            },
            on: {
              click: function ($event) {
                return _vm.changeModeTo("only_masked")
              },
            },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm._f("trans")("Only Masked Area")) +
                "\n      "
            ),
            _c(
              "div",
              {
                staticClass: "checkmark-box",
                class: {
                  active:
                    _vm.activeStage.settings.inpainting_area === "only_masked",
                },
              },
              [_c("i", { staticClass: "fa fa-check" })]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "runs-btn",
            class: {
              active:
                _vm.activeStage.settings.inpainting_area === "whole_picture",
            },
            on: {
              click: function ($event) {
                return _vm.changeModeTo("whole_picture")
              },
            },
          },
          [
            _vm._v(
              "\n      " + _vm._s(_vm._f("trans")("Whole Image")) + "\n      "
            ),
            _c(
              "div",
              {
                staticClass: "checkmark-box",
                class: {
                  active:
                    _vm.activeStage.settings.inpainting_area ===
                    "whole_picture",
                },
              },
              [_c("i", { staticClass: "fa fa-check" })]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }